import { CONFIRM_ALERT } from "common/constantMessage";
import { useEffect, useState } from "react";
import { Button, Modal, Row, Col, Form } from "react-bootstrap";
import { getSampleClientsList } from "store/services/practitionerService";

const LoadSampleClientPopup = ({ showPopup, closePopup, onConfirm }) => {
  const [selectedClients, setSelectedClients] = useState([]);
  const [clientList, setClientList] = useState([]);

  useEffect(() => {
    async function getSampleClients() {
      try {
        const response = await getSampleClientsList();
        if (response?.body?.length) {
          setClientList(response.body);
        }
      } catch (err) {
        console.error("Error getting sample clients", err);
      }
    }

    getSampleClients();
  }, []);

  const handleSelectClient = (clientId) => {
    setSelectedClients((prevSelected) =>
      prevSelected.includes(clientId)
        ? prevSelected.filter((id) => id !== clientId)
        : [...prevSelected, clientId]
    );
  };

  const handleConfirm = async () => {
    const isConfirmed = await CONFIRM_ALERT();
    if(!isConfirmed) {
      return;
    }
    onConfirm(selectedClients);
    closePopup();
    setSelectedClients([]);
  };

  return (
    <>
      <Modal
        show={showPopup}
        onHide={closePopup}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Load Sample Clients</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2">
            Please select the client(s) you want to load:
          </p>
          <Row>
            {clientList.map((client) => (
              <Col key={client.id} xs={12} className="mb-3">
                <div className="border rounded p-3 shadow-sm bg-light">
                  <div className="d-flex justify-content-between align-items-start">
                    <Form.Check
                      type="checkbox"
                      id={`client-${client.id}`}
                      label={
                        <div>
                          <div className="fw-semibold">
                            {client.first_name} {client.last_name}
                          </div>
                          <div className="text-muted small">
                            <strong>Email:</strong> {client.email}
                          </div>
                          <div className="text-muted small">
                            <strong>Category:</strong> {client.client_category}
                          </div>
                        </div>
                      }
                      checked={selectedClients.includes(client.id)}
                      onChange={() => handleSelectClient(client.id)}
                    />
                  </div>

                  <div className="mt-2 ps-4 border-start border-2 border-primary-subtle">
                    <div className="fw-semibold mb-1">Practitioner Details</div>
                    <div className="small">
                      <div>
                        <strong>Name:</strong> {client.practitioner_name || "N/A"}
                      </div>
                      <div>
                        <strong>Email:</strong> {client.practitioner_email || "N/A"}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={closePopup}>
            Close
          </Button>
          <Button
            variant="primary"
            disabled={selectedClients.length === 0}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LoadSampleClientPopup;
